<div class="main-settings">
    <p-tabView [scrollable]="true">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="{{miIcons.PASSWORD}} wh-16 inline-blick mr-2"></i>
                <span translate>settings.lbl_change_password</span>
            </ng-template>
            <div class="flex justify-content-end flex-wrap btn-with-links">
                <button pButton class="border-none bg-white default-text-light-black-color border-button" [label]="'cancel' | translate" (click)="onCancelChangePwd()"></button>
                <p-button class="flex align-items-center justify-content-center" [label]="changePasswordLabel" (click)="onChangePassword()"></p-button>
            </div>
            <div class="card background-not">
                <div class="font-semibold pb-4">
                    <label class="navigation-item-label font-20" translate>settings.lbl_change_password_uppercase</label>
                </div>
                <form [formGroup]="changePasswordForm">
                    <div class="grid login-box">
                        <div class="form-field col-6 md:col-10 lg:col-6 field">
                            <label class="flex" translate>lbl_current_password
                                <span class="required">*</span>
                            </label>
                            <div class="form-control">
                                <p-password 
                                    formControlName="currentPassword" 
                                    class="p-component p-element w-full" 
                                    [toggleMask]="true" 
                                    inputStyleClass="w-full"
                                    class="password-input"  
                                    [placeholder]="'lbl_enter_here' | translate">
                                </p-password>
                                <div class="mt-1">
                                    <label class="font-12" for="currentPassword" translate>lbl_enter_your_current_password_to_confirm</label>
                                </div>
                            </div>
                            @if (changePasswordForm.controls.currentPassword.errors && (changePasswordForm.controls.currentPassword.dirty || changePasswordForm.controls.currentPassword.touched)) {
                                <div class="form-errors mt-1 required-field">
                                    <div [hidden]="!changePasswordForm.controls.currentPassword.errors.required" translate>
                                        lbl_current_password_req
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="form-field col-6 md:col-10 lg:col-6 field"></div>
                        <div class="form-field col-6 md:col-10 lg:col-6 field">
                            <label class="flex" translate>lbl_new_password
                                <span class="required">*</span>
                            </label>
                            <div class="form-control">
                                <p-password 
                                formControlName="newPassword" 
                                class="p-component p-element w-full" 
                                [toggleMask]="true" 
                                inputStyleClass="w-full"
                                class="password-input"  
                                [placeholder]="'lbl_enter_here' | translate">
                                </p-password>
                                <div class="mt-1">
                                     <label class="font-12" for="newPassword" translate>
                                        {{ 'lbl_password_requirements' | translate:{minLength: minLength} }}
                                    </label>
                                </div>
                            </div>
                            @if (changePasswordForm.controls.newPassword.errors && (changePasswordForm.controls.newPassword.dirty || changePasswordForm.controls.newPassword.touched)) {
                                <div class="form-errors mt-1 required-field">
                                    <div [hidden]="!changePasswordForm.controls.newPassword.errors.required" translate>
                                        lbl_new_password_req
                                    </div>
                                </div>
                                <div class="form-errors mt-1 required-field">
                                    <div [hidden]="!changePasswordForm.controls.newPassword.errors.maxlength" translate>
                                        settings.lbl_error_message_new_password
                                    </div>
                                </div>
                                <div class="form-errors mt-1 required-field" [hidden]="!changePasswordForm.controls.newPassword.errors.pattern" translate>
                                    settings.password_pattern
                                </div>
                            }
                        </div>
                        <div class="form-field col-6 md:col-10 lg:col-6 field">
                            <label for="confirmPassword" class="flex" translate>lbl_confirm_new_password
                                <span class="required">*</span>
                            </label>
                            <div class="form-control">
                                <p-password 
                                formControlName="confirmPassword" 
                                class="p-component p-element w-full" 
                                [toggleMask]="true" 
                                inputStyleClass="w-full"
                                class="password-input"  
                                (input)="checkPasswordMatch()"
                                [placeholder]="'lbl_enter_here' | translate">
                                </p-password>
                            </div>
                            @if (changePasswordForm.controls.confirmPassword.errors && (changePasswordForm.controls.confirmPassword.dirty || changePasswordForm.controls.confirmPassword.touched)) {
                                <div class="form-errors mt-1 required-field">
                                    <div [hidden]="!changePasswordForm.controls.confirmPassword.errors.required" translate>
                                        lbl_confirm_new_password_req
                                    </div>
                                </div>
                                <div class="form-errors mt-1 required-field">
                                    <div [hidden]="!changePasswordForm.controls.confirmPassword.errors.maxlength" translate>
                                        settings.lbl_error_message_confirm_password
                                    </div>
                                </div>
                            }
                            <div class="form-errors required-field">
                                {{errorMessage}}
                            </div>
                         
                        </div>
                    </div>
                </form>
            </div>
            <div class="flex justify-content-end mr-10">
                <button pButton class="mr-2 mb-2 bg-color-gray default-text-light-black-color border-button " [label]="'cancel' | translate" (click)="onCancelChangePwd()"></button>
                <p-button class="mb-2 flex align-items-center justify-content-center" [label]="'lbl_change_password' | translate" (click)="onChangePassword()"></p-button>
            </div> 
        </p-tabPanel>
    </p-tabView>
</div>